'use client';
import React from 'react';

type RGBA = [number, number, number, number];
interface ModalProps {
    children: string | JSX.Element | JSX.Element[];
    headerTitle?: string;
    showHeader?: boolean;
    footer?: string;
    showFooter?: boolean;
    hideCloseButton?: boolean;
    backdropColor?: RGBA;
    showModal: boolean;
    closeEvent?: () => void;
}

const Modal: React.FC<ModalProps> = props => {
    const {
        children,
        headerTitle,
        showHeader = false,
        footer,
        showFooter = false,
        showModal,
        hideCloseButton = false,
        backdropColor = [0, 0, 0, 0.9] as RGBA,
        closeEvent,
    } = props;

    return (
        <>
            {showModal && (
                <div
                    className="flex justify-center items-center fixed top-0 left-0 right-0 z-50 w-full h-full overflow-hidden md:inset-0"
                    style={{
                        backgroundColor: `rgba(${backdropColor[0]}, ${backdropColor[1]}, ${backdropColor[2]}, ${backdropColor[3]})`,
                    }}
                >
                    <div className="relative w-full max-w-2xl max-h-[90vh] overflow-y-auto bg-white rounded-lg shadow dark:bg-gray-700">
                        {showHeader && (
                            <div className="flex items-start justify-between p-4 border-b rounded-t dark:border-gray-600">
                                <h3 className="text-xl font-semibold text-gray-900 dark:text-white">
                                    {headerTitle}
                                </h3>
                                {!hideCloseButton && closeEvent && (
                                    <button
                                        className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white"
                                        onClick={() =>
                                            closeEvent && closeEvent()
                                        }
                                        type="button"
                                    >
                                        <svg
                                            aria-hidden="true"
                                            className="w-5 h-5"
                                            fill="currentColor"
                                            viewBox="0 0 20 20"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                clipRule="evenodd"
                                                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                                fillRule="evenodd"
                                            ></path>
                                        </svg>
                                        <span className="sr-only">
                                            Close modal
                                        </span>
                                    </button>
                                )}
                            </div>
                        )}
                        <div className="p-4 max-h-[90vh] overflow-y-auto">
                            {children}
                        </div>
                        {showFooter && (
                            <div className="flex items-center p-6 space-x-2 border-t border-gray-200 rounded-b dark:border-gray-600">
                                {footer}
                            </div>
                        )}
                    </div>
                </div>
            )}
        </>
    );
};

export default Modal;
